import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { ChevronRightIcon } from "@heroicons/react/24/outline";

import ConfirmationModalNew from "../common/ConfirmationModalNew";
import Button from "./Button";
import CustomInput from "../common/CustomInput";
import NewToolTip from "./New-ToolTip";
import OTCReferNote from "./tooltip/otc-refer";

const EndServiceModel = ({
  title,
  open = true,
  content,
  titleClassName = "",
  showContinueWithNoRef = true,
  disabledContinueWithNoRef = false,
  showContinueAndRef = true,
  disabledContinueAndRef = false,
  showOTCConsultAndRef = true,
  disabledOTCConsultAndRef = true,
  showEndServiceAndRef = true,
  disabledEndServiceAndRef = false,
  className = "",
  handleClose = () => {},
  handleContinue = () => {},
  handleEndService = () => {},
}) => {
  //Start: to mark which action is chosen by user
  const { serviceId } = useParams();
  const [continueWithNoRef, setContinueWithNoRef] = useState(false);
  const [continueAndRef, setContinueAndRef] = useState(false);
  const [endService, setEndService] = useState(false);
  const [otcConsultAndRef, setOtcConsultAndRef] = useState(false);
  //End
  const [explanation, setExplanation] = useState("");
  const [allowContinue, setAllowContinue] = useState(false);
  const [pharmacistDecision, setPharmacistDecision] = useState(false);
  // Confirmation popup for End Service & Refer
  const [openConfirmEnd, setOpenConfirmEnd] = useState(false);

  useEffect(() => {
    if (continueWithNoRef || continueAndRef) {
      if (pharmacistDecision) {
        setAllowContinue(true);
      } else {
        setAllowContinue(false);
      }
    }
  }, [continueWithNoRef, continueAndRef, pharmacistDecision]);

  useEffect(() => {
    if (!open) setAllowContinue(false);
  }, [open]);

  // to get end service actions
  const getActions = () => {
    return (
      <div className="mt-8 flex flex-col gap-5">
        {/* when we have to show only continue and not other action like end service or otc */}
        {!showEndServiceAndRef && !showOTCConsultAndRef && (
          <div className="">
            <Button
              type="primary-outline"
              text="Continue"
              className="w-full !bg-REELTeal !text-white !border-REELTeal hover:!bg-teal-200"
              onClick={() => {
                handleContinue();
              }}
            />
          </div>
        )}
        {/* When we have to show OTC, End service, Continue with ref and Continue without ref */}
        {showContinueWithNoRef &&
          showEndServiceAndRef &&
          showOTCConsultAndRef && (
            <div className="">
              <Button
                type="primary-outline"
                text="Continue Service with NO Referral"
                className={continueWithNoRef ? "w-full selected" : "w-full"}
                disabled={disabledContinueWithNoRef}
                onClick={() => {
                  if (!continueWithNoRef) {
                    resetState();
                    setContinueWithNoRef(true);
                  }
                }}
              />
            </div>
          )}
        {showContinueWithNoRef && continueWithNoRef && (
          <CustomInput
            name="explanation"
            label="Explanation"
            placeholder="Enter Explanation"
            className=""
            type="text"
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
            autoFocus={true}
            focus={true}
          />
        )}
        {showContinueWithNoRef && continueWithNoRef && (
          <div className="col-span-12 text-body-sm flex items-center text-gray-800">
            <input
              id="pharmacistDecision"
              value={pharmacistDecision}
              onChange={(e) => setPharmacistDecision(e.target.checked)}
              className="!border-gray-400"
              name="pharmacistDecision"
              type="checkbox"
            />
            <label htmlFor="pharmacistDecision" className="ml-2">
              Pharmacist Clinical Decision: Continue with Service
            </label>
          </div>
        )}
        {showContinueAndRef && showEndServiceAndRef && showOTCConsultAndRef && (
          <div className="">
            <Button
              type="primary-outline"
              text="Continue Service & Refer"
              className={continueAndRef ? "w-full selected" : "w-full"}
              disabled={disabledContinueAndRef}
              onClick={() => {
                if (!continueAndRef) {
                  resetState();
                  setContinueAndRef(true);
                }
              }}
            />
          </div>
        )}
        {showContinueAndRef && continueAndRef && (
          <CustomInput
            name="explanation"
            label="Explanation"
            placeholder="Enter Explanation"
            className=""
            type="text"
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
            autoFocus={true}
            focus={true}
          />
        )}
        {showContinueAndRef && continueAndRef && (
          <div className="col-span-12 text-body-sm flex items-center text-gray-800">
            <input
              id="pharmacistDecision"
              value={pharmacistDecision}
              onChange={(e) => setPharmacistDecision(e.target.checked)}
              name="pharmacistDecision"
              className="!border-gray-400"
              type="checkbox"
            />
            <label htmlFor="pharmacistDecision" className="ml-2">
              Pharmacist Clinical Decision: Continue with Service
            </label>
          </div>
        )}
        {showOTCConsultAndRef && (
          <div>
            <Button
              type="primary-outline"
              text="OTC Consult & Refer"
              className={
                otcConsultAndRef
                  ? "w-full !opacity-100 selected"
                  : "w-full !opacity-100"
              }
              disabled={disabledOTCConsultAndRef}
              onClick={() => {
                if (!otcConsultAndRef) {
                  resetState();
                  setOtcConsultAndRef(true);
                }
              }}
              toolTipId="otc-refer"
              TooltipComponent={OTCReferNote}
              tooltipPlace="right"
            />
          </div>
        )}
        {showEndServiceAndRef && (
          <div className="">
            <Button
              type="primary-outline"
              text="End Service & Refer"
              className={endService ? "w-full selected" : "w-full"}
              disabled={disabledEndServiceAndRef}
              onClick={() => {
                if (!endService) {
                  resetState();
                  setEndService(true);
                  setAllowContinue(true);
                  setOpenConfirmEnd(true); // open confirmation popup
                }
              }}
            />
          </div>
        )}
      </div>
    );
  };

  // to get end service content
  const getContent = () => {
    return (
      <div className="mb-8 !text-sm-body !text-gray-800">
        {content()}
        {showEndServiceAndRef && (
          <>
            <br />
            <span>Stop Assessment</span> <br />
            <span>Refer to Primary Healthcare Provider</span>
          </>
        )}
        {getActions()}
        {showEndServiceAndRef && showOTCConsultAndRef && (
          <>
            <p className="mt-8 mb-4 !text-xs-body text-gray-800">
              Referral forms are generated at the end of the service.
            </p>
            <br />
            <button
              className={`float-right m-2 mb-6 h-[38px] w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex 
            border transition-all duration-300 items-center font-semibold justify-center px-3 py-4 ${
              !allowContinue && "opacity-40 pointer-events-none"
            }`}
              disabled={!allowContinue}
              onClick={() => onContinue()}
            >
              <h3 className="text-body-md font-semibold text-white">
                Continue
              </h3>
              <ChevronRightIcon className="w-4 ml-2 h-4 text-white" />
            </button>
          </>
        )}
      </div>
    );
  };

  const resetState = () => {
    setContinueAndRef(false);
    setContinueWithNoRef(false);
    setOtcConsultAndRef(false);
    setEndService(false);
    setExplanation("");
    setAllowContinue(false);
    setPharmacistDecision(false);
  };

  // Record this popup's decision so the referrals UI hides the Referral Card only if all decisions are 'no referral'.
  const recordReferralDecision = (serviceId, referRequested) => {
    const key = `referralDecisions_${serviceId}`;
    const existing = JSON.parse(sessionStorage.getItem(key) || "[]");
    existing.push(Boolean(referRequested));
    sessionStorage.setItem(key, JSON.stringify(existing));
  };

  const onContinue = () => {
    if (allowContinue) {
      if (continueAndRef || continueWithNoRef) {
        resetState();
        recordReferralDecision(serviceId, !continueWithNoRef);
        handleContinue(continueAndRef, explanation);
      } else if (endService) {
        handleEndService();
      } else if (otcConsultAndRef) {
        // TODO: OTC consult and ref logic goes here.
      }
    }
  };

  return (
    <>
      <ConfirmationModalNew
        open={open}
        title={title}
        titleClassName={titleClassName}
        className={className}
        content={() => getContent()}
        hideActions={true}
        onCross={() => handleClose()}
      />

      {/* Confirm End Service & Refer */}
      <ConfirmationModalNew
        open={openConfirmEnd}
        title="Confirm End Service & Refer"
        className="!min-w-[630px] [&_h3]:text-[24px]"
        confirmText="End Service & Continue"
        cancelText="Cancel"
        content={() => (
          <div className="!text-[16px] !text-gray-800">
            <p className="mb-4">You are about to end this service and create a referral due to a red flag.</p>
            <p>All progress will be saved up to this point.</p>
          </div>
        )}
        onCross={() => setOpenConfirmEnd(false)}
        handleClose={() => setOpenConfirmEnd(false)}
        confirmAction={() => {
          setOpenConfirmEnd(false);
          handleEndService();
        }}
      />
    </>
  );
};

export default EndServiceModel;
